module.exports = __webpack_public_path__ + "static/media/node.5c376133.svg";